import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="index-1">
      <div className="container">
        <div className="copyright col-lg-12">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              Copyright © {currentYear} 
              <span className="separator-pipesign"></span> All Rights Reserved 
              <span className="separator-pipesign"></span> Designed By <a href="/">Teknoma</a>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-right">
              {/* Additional footer content can go here */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;